export const removeHolidays = (weekDays, holidays) => {
  return weekDays.filter((day) => !holidays.includes(day))
}
